module.exports = __webpack_public_path__ + "c47b10365878e443aaa7e37fc47c4313.png";